exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui.dropdown .menu>.item.current{background:rgba(0,0,0,.05)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5b089780!./~/vue-loader/lib/selector.js?type=styles&index=2!./src/components/lib/MultiSelect.vue
// module id = 152
// module chunks = 0